<template>
  <div class="view-error">
    <app-empty-data
      title="Упс... Попробуем сначала?"
      description="Кажется, что-то пошло не так. Возможно, страница была удалена.  Давайте вернёмся на главную."
      img="/static/images/oops.svg"
    ></app-empty-data>
  </div>
</template>

<script>
export default {
  name: 'ViewError',
  components: {
    AppEmptyData: () => import('@/components/common/AppEmptyData'),
  },
};
</script>

<style lang="scss">
.view-error {
  .app-empty-data {
    margin-bottom: 0;
  }
}
</style>
